import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import store from 'store';

import InfiniteScrollContainer from '@common/components/InfiniteScrollContainer';

import NotificationListItem from './Item';
import { StyledNotificationsListWrap } from './styled';

function NotificationsList() {
	const { t } = useTranslation();
	const { notifications, services } = store;

	const handleLoadMore = async (nextPage: number) => {
		notifications.setPage(nextPage);
		await notifications.fetch({ service_id: services.current.id });
	};

	if (notifications?.sortedNotifications?.length < 1) {
		return <Typography>{t('notifications.empty')}</Typography>;
	}

	return (
			<InfiniteScrollContainer
				isLoading={notifications.loading}
				onLoadMore={handleLoadMore}
				currentPage={notifications.page}
				hasMore={notifications.hasMore}
			>
				<StyledNotificationsListWrap>
					{notifications.sortedNotifications.map((notification) => (
						<NotificationListItem notification={notification} key={notification.id} />
					))}
				</StyledNotificationsListWrap>
			</InfiniteScrollContainer>
	);
}

export default observer(NotificationsList);
